/* ap-preisfenster.js — die Preiszusage unter dem Preis.
 *
 * Der Streifen ist im Markup AUSGEBLENDET und zeigt sich erst, wenn die App eine echte
 * Frist geliefert hat. Das ist Absicht: die Frist ist eine Eigenschaft DIESES Produkts
 * (bis wann seine Erhoehung zurueckgehalten wird) und kann im Theme nicht gerechnet
 * werden. Lieber gar kein Streifen als einer mit geratener Uhrzeit.
 *
 * WAS DIE ZUSAGE TRAEGT: In der App haelt ein Riegel jede PreiserhOEHUNG zurueck, bis die
 * zuletzt angezeigte Frist abgelaufen ist (app/lib/pricing/preisfenster.ts). Senkungen
 * laufen jederzeit durch. Ohne diesen Riegel darf der Streifen nicht eingeschaltet werden
 * — dann waere die Aussage unwahr, und eine unwahre Befristung ist nach Anhang zu § 3
 * Abs. 3 UWG Nr. 7 ohne jede Abwaegung unlauter.
 *
 * WARUM DAS KEIN ABGEMAHNTER COUNTDOWN IST: Die Frist liegt auf einem festen
 * Wanduhr-Raster (:00/:30) und gehoert dem Produkt, nicht dem Besuch. Zwei Besucher sehen
 * dieselbe Uhrzeit, und Neuladen verlaengert nichts — es gibt gar nichts, was von vorn
 * beginnen koennte. Genau diese Eigenschaft ist die Verteidigung.
 *
 * DREI GRUENDE, AUS DENEN SICH DER STREIFEN SELBST ENTFERNT — alle derselbe Gedanke,
 * naemlich dass eine falsche Zusage schlechter ist als keine:
 *   1. Die App liefert `until: null`. Sie sagt dann nichts zu, weil sie nichts zusagen
 *      KANN (eine Erhoehung ist ueberfaellig und geht im naechsten Lauf raus).
 *   2. Die Uhr des Besuchers weicht um mehr als fuenf Minuten von der Serverzeit ab. Der
 *      Kunde kann nicht wissen, dass seine Uhr schuld ist — er saehe ein gebrochenes
 *      Versprechen.
 *   3. Die Frist laeuft waehrend des Betrachtens ab. Danach gilt sie nicht mehr, also
 *      steht sie auch nicht mehr da.
 */
(function () {
  'use strict';

  var SKEW_TOLERANCE_MS = 5 * 60 * 1000;
  var PROXY = '/apps/tyre-search/preisfenster';

  var strip = document.querySelector('[data-ap-preisfenster]');
  if (!strip) return;

  var key = strip.getAttribute('data-key');
  var offsetSec = parseOffset(strip.getAttribute('data-shop-offset'));
  if (!key || offsetSec === null) return drop();

  /* "+0200" / "-0530" -> Sekunden. null, wenn unlesbar. Der Versatz kommt aus Liquid und
     dreht die ANZEIGE in Ortszeit des Shops; die Frist selbst ist ein absoluter
     Zeitpunkt und braucht ihn nicht. */
  function parseOffset(raw) {
    if (!raw) return null;
    var m = /^([+-])(\d{2})(\d{2})$/.exec(raw.trim());
    if (!m) return null;
    var seconds = parseInt(m[2], 10) * 3600 + parseInt(m[3], 10) * 60;
    return m[1] === '-' ? -seconds : seconds;
  }

  function drop() {
    if (strip && strip.parentNode) strip.parentNode.removeChild(strip);
    strip = null;
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function start(untilMs) {
    var zeit = strip.querySelector('.ap-preisfenster__time');
    var rest = strip.querySelector('.ap-preisfenster__count');

    /* Die Uhrzeit steht fest, sobald die Frist bekannt ist — sie wird einmal gesetzt und
       nicht jede Sekunde neu formatiert. */
    var ortszeit = new Date(untilMs + offsetSec * 1000);
    if (zeit) zeit.textContent = pad(ortszeit.getUTCHours()) + ':' + pad(ortszeit.getUTCMinutes());

    var timer = null;

    function tick() {
      var uebrig = Math.floor((untilMs - Date.now()) / 1000);
      if (uebrig <= 0) {
        if (timer) clearInterval(timer);
        return drop();
      }
      if (rest) {
        rest.textContent = '(' + pad(Math.floor(uebrig / 60)) + ':' + pad(uebrig % 60) + ')';
        rest.hidden = false;
      }
    }

    tick();
    if (!strip) return;
    strip.hidden = false;
    timer = setInterval(tick, 1000);

    /* Ein Hintergrund-Reiter drosselt setInterval. Ohne das stuende beim Zurueckwechseln
       fuer einen Moment eine alte Restzeit da — oder eine abgelaufene Frist. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tick();
    });
  }

  function hole() {
    fetch(PROXY + '?ean=' + encodeURIComponent(key), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (!data || !data.until || !data.serverNow) return drop();

        var serverMs = Date.parse(data.serverNow);
        var untilMs = Date.parse(data.until);
        if (!isFinite(serverMs) || !isFinite(untilMs)) return drop();
        if (Math.abs(serverMs - Date.now()) > SKEW_TOLERANCE_MS) return drop();
        if (untilMs - Date.now() <= 0) return drop();

        start(untilMs);
      })
      .catch(drop);
  }

  /* SOFORT holen, nicht im Leerlauf.
   *
   * Hier stand bis 01.09.2026 ein requestIdleCallback mit 3 s Frist — gedacht als
   * Ruecksicht auf den groessten Bildaufbau. Der Gedanke war halb richtig und im Ergebnis
   * falsch: der Streifen sitzt ZWISCHEN Preis und Kaufknopf. Taucht er zwei Sekunden nach
   * dem Laden auf, schiebt er Bestandszeile, "In den Warenkorb" und die Zahlungshinweise
   * nach unten — ein Layoutsprung mitten in der Buybox, und CLS ist eine der Kennzahlen,
   * an denen diese Seite gemessen wird. Gegen LCP optimiert, CLS dabei eingehandelt.
   *
   * Dieses Skript laeuft ohnehin `defer`, also nach dem HTML-Parsen und vor
   * DOMContentLoaded. Der Abruf hier startet den Sprung so frueh, dass sich noch nichts
   * gesetzt hat. Er kostet fast nichts: eine Anfrage gleicher Herkunft mit rund 80 Byte
   * Antwort — der Leerlauf-Aufschub war bei dieser Groesse ohnehin theoretisch.
   *
   * Platz reservieren waere der andere Weg gewesen und ist bewusst verworfen: fuer jedes
   * Produkt, dem die App gerade nichts zusagen kann (und diese Faelle gehoeren zum Bau),
   * klaffte dann dauerhaft eine leere Luecke unter dem Preis. */
  hole();
})();
